import { render, staticRenderFns } from "./startNumber.vue?vue&type=template&id=41f1a21e&scoped=true"
import script from "./startNumber.vue?vue&type=script&lang=js"
export * from "./startNumber.vue?vue&type=script&lang=js"
import style0 from "./startNumber.vue?vue&type=style&index=0&id=41f1a21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1a21e",
  null
  
)

export default component.exports